import { render, staticRenderFns } from "./IBSTaxes.vue?vue&type=template&id=9f55c586&"
import script from "./IBSTaxes.vue?vue&type=script&lang=js&"
export * from "./IBSTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports